$(function(){
    
    $('.new-wap-menu-unclick').click(function(){
        $('.new-wap-menu-outside').toggleClass('new-wap-menu-on');
    })
    $('#apollo-menu .navbar-toggle').click(function(){
        $('.new-wap-menu-outside').toggleClass('new-wap-menu-on');
    })
  
      function new_wap_menu_top(){
            var header_height = $('#header').height();
            var win_height = $(window).height();
            var wap_menu_height = win_height - header_height;
           $('.new-wap-menu-outside').css("top",header_height);
           $('.new-wap-menu-outside').css("height",wap_menu_height);
        }
      
      new_wap_menu_top();
  
      $(window).resize(function(){
                  new_wap_menu_top();
      });
  
      $(window).scroll(function(){
                  new_wap_menu_top();
      });
      
  
      
    })